import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    private sidebarVisible: boolean = false;

    // sidebarToggle(toggleButton: Element): void {
    //     if (this.sidebarVisible === false) {
    //         this.sidebarOpen(toggleButton);
    //     } else {
    //         this.sidebarClose(toggleButton);
    //     }
    // }

    // sidebarOpen(toggleButton: Element): void {
    //     const body = document.getElementsByTagName('body')[0];
    //     setTimeout(function () {
    //         toggleButton.classList.add('toggled');
    //     }, 500);
    //     body.classList.add('nav-open');
    //     this.sidebarVisible = true;
    // }

    // sidebarClose(toggleButton: Element): void {
    //     const body = document.getElementsByTagName('body')[0];
    //     toggleButton.classList.remove('toggled');
    //     this.sidebarVisible = false;
    //     body.classList.remove('nav-open');
    // }
}
